import { render, staticRenderFns } from "./knowledge-category.vue?vue&type=template&id=1893d43e&"
import script from "./knowledge-category.vue?vue&type=script&lang=js&"
export * from "./knowledge-category.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports